import React from 'react';
import logo from '../assets/logo.png';
import salonImg from '../assets/salon.jpeg';
import { BOOKING_URL, branch } from '../data/siteData';

const features = [
  'Sertifikalı güzellik uzmanları',
  'Premium kalite ürünler',
  'Hijyenik ve steril ortam',
  'Kişiselleştirilmiş bakım planı',
  'Ücretsiz danışmanlık',
  'Online randevu sistemi',
];

const About: React.FC = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <div className="about-content">

          {/* Image side */}
          <div className="about-image-wrapper">
            <img src={salonImg} alt="Bloome Beauty Batıkent" className="main-img" />
            <div style={{ position: 'absolute', inset: 0, borderRadius: 20, background: 'linear-gradient(to top, rgba(255,20,147,0.2) 0%, transparent 60%)', pointerEvents: 'none' }} />

            {/* Rating badge */}
            <div className="about-badge">
              <div className="rating">4.9</div>
              <div className="stars">★★★★★</div>
              <div className="review-count">1000+ Yorum</div>
            </div>

            {/* Logo card */}
            <div className="about-logo-card">
              <div className="logo-circle-sm">
                <img src={logo} alt="Bloome" />
              </div>
              <div>
                <p style={{ fontFamily: "'Playfair Display', serif", fontWeight: 700, fontSize: '0.9rem', color: '#ff1493' }}>Bloome Beauty</p>
                <p style={{ fontSize: '0.75rem', color: '#888', fontWeight: 300 }}>{branch.shortName}, Ankara</p>
              </div>
            </div>
          </div>

          {/* Text side */}
          <div className="about-text-wrapper">
            <span className="overline">Hakkımızda</span>
            <h2>
              Güzelliğiniz için<br />
              <span className="highlight">en iyi deneyim</span>
            </h2>
            <div className="about-divider" />
            <p>
              Bloome Beauty Batıkent olarak Velux AVM'de sizi bekliyoruz. Protez tırnak, nail art,
              kalıcı oje, manikür-pedikür, kirpik lifting, ipek kirpik ve kaş laminasyonu hizmetlerimizle
              güzelliğinizi profesyonel bir dokunuşla tamamlıyoruz.
            </p>
            <p>
              Uzman ekibimiz ve premium ürünlerimizle her müşterimize özel, kişiselleştirilmiş bir
              deneyim sunuyoruz.
            </p>

            <ul className="about-features">
              {features.map((f) => (
                <li key={f}>{f}</li>
              ))}
            </ul>

            <div className="about-cta">
              <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="btn btn-primary">
                Randevu Al
              </a>
              <a href={`tel:${branch.phonePlain}`} className="btn btn-outline">
                📞 {branch.phone}
              </a>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default About;
